module.exports = __webpack_public_path__ + "static/media/www.jiminny.com.5e195825.png";